import apiClient from './apiClient';

interface CalendarStatus {
  success: boolean;
  message: string;
  isConnected: boolean;
}

interface AuthUrlResponse {
  url: string;
}

class CalendarService {
  /**
   * Get the authentication URL for Google Calendar
   * @returns URL to redirect the user to for Google Calendar authentication
   */
  async getAuthUrl(): Promise<string> {
    try {
      const response = await apiClient.get<AuthUrlResponse>('/calendar/auth');
      return response?.url || '';
    } catch (error) {
      console.error('Error getting Google Calendar auth URL:', error);
      throw error;
    }
  }

  /**
   * Check if the user has connected their Google Calendar
   * @returns Boolean indicating if the calendar is connected
   */
  async getCalendarStatus(): Promise<boolean> {
    try {
      const response = await apiClient.get<CalendarStatus>('/calendar/status');
      return response?.isConnected || false;
    } catch (error) {
      console.error('Error checking calendar status:', error);
      return false;
    }
  }

  /**
   * Disconnect the user's Google Calendar
   * @returns Boolean indicating if the disconnection was successful
   */
  async disconnectCalendar(): Promise<boolean> {
    try {
      const response = await apiClient.delete<{success: boolean}>('/calendar/disconnect');
      return response?.success || false;
    } catch (error) {
      console.error('Error disconnecting calendar:', error);
      return false;
    }
  }
}

const calendarService = new CalendarService();
export default calendarService; 